export default __webpack_public_path__ + "static/media/user-delete.b7bb34a4.svg";